import React, { useState, useEffect } from "react";
import NoInternet from "./NoInternet";
import { useTranslation, withTranslation } from "react-i18next";
import styled from "styled-components";
import { Button } from "antd";

const NetworkStatusOverlay = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { t } = useTranslation();
  const updateNetworkStatus = () => {
    setIsOnline(navigator.onLine);
  };

  useEffect(() => {
    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);

    return () => {
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
    };
  }, []);

  return (
    <div>
      {/* Overlay div */}
      {!isOnline && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "#fff",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            fontSize: "24px",
          }}
        >
          <Wrapper>
            <h4>{t("common.noInternet")}</h4>
            <div className="subtitle1">{t("common.noInternetDecs")}</div>
            <Button
              size="large"
              className="reload-btn"
              onClick={() => {
                window.location.reload();
              }}
            >
              {t("common.reloadPage")}
            </Button>
            <NoInternet />
          </Wrapper>
        </div>
      )}
    </div>
  );
};

export default withTranslation()(NetworkStatusOverlay);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h4 {
    font-weight: 700;
  }
  .subtitle1 {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #6e6b7b;
  }
  .reload-btn {
    font-weight: 400;
    font-size: 16px;
    color: #fff;
    background-color: ${(props) => props.theme.main};
    border-radius: 6px;
    padding: 8px 16px;
    margin-top: 24px;
  }
`;
